var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v4",attrs:{"id":"v4"}},[_c('header-v4'),_c('div',{staticClass:"g-main f-clearfix"},[(!this.$route.meta.nomenu)?_c('menu-v4'):_vm._e(),_c('router-view')],1),_c('contact'),_c('banAccount'),_c('img',{staticStyle:{"width":"1px","height":"1px","opacity":"0","position":"fixed"},attrs:{"src":_vm.src,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }